import { render } from "./branch-position.vue?vue&type=template&id=bb757d48"
import script from "./branch-position.vue?vue&type=script&lang=js"
export * from "./branch-position.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__